<template>
  <el-card shadow="always" :body-style="{ padding: '20px' }">
    <!-- <div slot="header">
      <span>账单详情</span>
    </div> -->
    <!-- card body -->

    <el-descriptions title="账单详情" :column="5">
      <template
        v-if="detail && detail.status === STATUS.PENDING_BUSINESS_REVIEW"
        slot="extra"
      >
        <el-button type="primary" size="small" @click="showConfirmDialog">
          提交账单</el-button
        >
        <el-button type="danger" size="small" @click="handleBillCancel">
          作废
        </el-button>
      </template>
      <template
        v-if="detail && detail.status === STATUS.PENDING_FINANCIAL_REVIEW"
        slot="extra"
      >
        <el-button
          type="primary"
          size="small"
          style="margin-right: 16px"
          @click="showConfirmReviewPassDialog"
        >
          审核通过</el-button
        >
        <el-button type="primary" size="small" @click="showReviewRejectDialog">
          审核驳回</el-button
        >
      </template>
      <template
        v-if="
          detail &&
          detail.clearing_form_type === SETTLEMENT_OPTIONS.BILL_PAYMENT &&
          detail.status === STATUS.BILLS_TO_BE_PAID
        "
        #extra
      >
        <el-button
          type="primary"
          size="small"
          style="margin-right: 16px"
          @click="handleShowDoneDialog"
        >
          线下支付
        </el-button>
      </template>

      <el-descriptions-item label="账单编号">{{
        detail && detail.bill_no
      }}</el-descriptions-item>
      <el-descriptions-item label="账单生成时间">{{
        detail && detail.created_at
      }}</el-descriptions-item>
      <el-descriptions-item label="账期"
        >{{ detail && detail.reporting_period }}
      </el-descriptions-item>
      <el-descriptions-item
        v-if="
          detail &&
          (detail.status === STATUS.PENDING_PURCHASE_ORDER_DEDUCTION ||
            detail.status === STATUS.BILLS_TO_BE_PAID ||
            detail.status === STATUS.DONE)
        "
        label="账单确认时间"
        >{{ detail && detail.confirm_time }}
      </el-descriptions-item>
      <el-descriptions-item
        label="账单状态"
        :content-style="{
          'font-weight': 'bold',
          color: '#333',
          'font-size': '18px',
          'line-height': '18px',
        }"
      >
        <el-tooltip
          :disabled="!(detail && detail.remark)"
          effect="dark"
          :content="detail && detail.remark"
          placement="top-start"
        >
          <div>{{ detail && detail.status_msg }}</div>
        </el-tooltip>
      </el-descriptions-item>
    </el-descriptions>
    <el-dialog
      title="提示"
      :visible.sync="dialogRejectVisible"
      width="30%"
      @close="handleRejectClose"
    >
      <div>确定账单审核驳回？</div>
      <el-form
        ref="rejectForm"
        :model="rejectForm"
        :rules="rejectRules"
        label-width="0px"
        :inline="false"
        size="normal"
      >
        <el-form-item label="" prop="reason">
          <el-input
            v-model="rejectForm.reason"
            type="textarea"
            placeholder="请输入原因，最多50个字"
            size="normal"
            :maxlength="50"
            clearable
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="dialogRejectVisible = false">取消</el-button>
        <el-button type="primary" @click="handleConfirmReject"> 确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="上传凭证"
      :visible.sync="dialogDoneVisible"
      width="30%"
      @close="handleDoneClose"
    >
      <el-form
        ref="formDone"
        :model="formDone"
        :rules="doneRules"
        label-width="80px"
      >
        <el-form-item label="凭证图片" prop="receipt">
          <ys-upload
            v-model="formDone.receipt"
            :max="constantMap.maxImage"
          ></ys-upload>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogDoneVisible = false">取消</el-button>
        <el-button type="primary" @click="handleConfirmDone"> 确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogConfirmSubmitVisible"
      width="30%"
      @close="handleConfirmSubmitClose"
    >
      <span>确定提交账单？</span>
      <span slot="footer">
        <el-button @click="dialogConfirmSubmitVisible = false">取消</el-button>
        <el-button type="primary" @click="handleConfirmSubmit">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogConfirmReviewPassVisible"
      width="30%"
      @close="handleConfirmReviewPassClose"
    >
      <span>确定账单审核通过？</span>
      <span slot="footer">
        <el-button @click="dialogConfirmReviewPassVisible = false"
          >取消</el-button
        >
        <el-button type="primary" @click="handleConfirmReviewPass">
          确定</el-button
        >
      </span>
    </el-dialog>

    <el-card shadow="never" style="margin-bottom: 16px">
      <!-- card body -->
      <div
        class="header-bar"
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <div>
          <span style="margin-right: 16px"
            ><span style="font-weight: bold">商家ID：</span
            ><span style="color: #666">{{
              detail && detail.supply_id
            }}</span></span
          >
          <span style="margin-right: 16px"
            ><span style="font-weight: bold">商家名称：</span
            ><span style="color: #666">{{
              detail && detail.supply_name
            }}</span></span
          >
          <span style="margin-right: 16px"
            ><span style="font-weight: bold">让利计费规则获取时间：</span
            ><span style="color: #666">{{
              detail && detail.rule_get_time
            }}</span></span
          >
        </div>
        <div
          v-if="detail && detail.status === STATUS.PENDING_BUSINESS_REVIEW"
          style="float: right"
        >
          <span>让利计费规则：</span>
          <el-button
            type="warning"
            size="small"
            @click="showRefetchConfirmDialog"
            >重新获取计费规则并更新账单</el-button
          >
        </div>
        <el-dialog
          title="提示"
          :visible.sync="dialogRefetchConfirmVisible"
          width="30%"
          @close="handleRefetchConfirmClose"
        >
          <div>确定重新获取计费规则并更新账单？</div>
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-width="0px"
            :inline="false"
            size="normal"
          >
            <el-form-item label="" prop="reason">
              <el-input
                v-model="form.reason"
                type="textarea"
                placeholder="请输入原因，最多50个字"
                size="normal"
                :maxlength="50"
                clearable
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-form>

          <span slot="footer">
            <el-button @click="dialogRefetchConfirmVisible = false"
              >取消</el-button
            >
            <el-button type="primary" @click="handleConfirmRefetch">
              确定</el-button
            >
          </span>
        </el-dialog>
      </div>
      <el-table :data="tableAccountingRules" border stripe>
        <el-table-column type="index" width="50" label="序号">
        </el-table-column>
        <el-table-column
          v-for="(col, index) in columnsAccountingRules"
          :key="index"
          :prop="col.prop"
          :label="col.label"
          :width="col.width"
        >
        </el-table-column>
      </el-table>
    </el-card>

    <el-card shadow="never" style="margin-bottom: 16px">
      <!-- card body -->
      <div
        class="header-bar"
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <span>商品销量汇总表</span>
        <div>
          <el-button style type="success" size="mini" @click="exportList">
            导出列表</el-button
          >
          <el-button
            style
            type="success"
            size="mini"
            @click="exportGoodsDetail"
          >
            导出商品明细</el-button
          >
        </div>
      </div>
      <el-table
        :data="tableSalesVolumeSummary"
        border
        stripe
        show-summary
        :summary-method="getSummariesForSalesVolume"
        :max-height="850"
      >
        <template v-for="(col, index) in columnsSalesVolumeSummary">
          <el-table-column
            v-if="col.prop === 'goods_no'"
            :key="index"
            :prop="col.prop"
            :label="col.label"
            :width="col.width"
          >
            <template slot-scope="scope">
              <a
                :href="`${
                  isProduction
                    ? 'https://d0k0.yishouapp.com'
                    : 'http://test1.yishou.com'
                }/newos/goods/goodsLibList?goods_no=${scope.row.goods_no}`"
                target="_blank"
                style="text-decoration: none"
                >{{ scope.row.goods_no }}</a
              >
            </template>
          </el-table-column>
          <el-table-column
            v-else
            :key="index"
            :prop="col.prop"
            :label="col.label"
            :width="col.width"
          >
          </el-table-column>
        </template>
      </el-table>
    </el-card>
    <el-card shadow="never" style="margin-bottom: 16px">
      <!-- card body -->
      <div class="header-bar">
        <span>销售达标汇总表</span>
      </div>
      <el-table
        :data="tableReachSalesTargetSummary"
        border
        stripe
        show-summary
        :summary-method="getSummariesForReachSalesTarget"
      >
        <el-table-column
          v-for="(col, index) in columnsReachSalesTargetSummary"
          :key="index"
          :prop="col.prop"
          :label="col.label"
          :width="col.width"
        >
        </el-table-column>
      </el-table>
    </el-card>

    <el-card shadow="never" style="margin-bottom: 16px">
      <!-- card body -->
      <div class="header-bar">
        <span>金额明细</span>
      </div>
      <el-table :data="tableAmountDetails" border stripe>
        <el-table-column
          v-for="(col, index) in columnsAmountDetails"
          :key="index"
          :prop="col.prop"
          :label="col.label"
          :width="col.width"
        >
        </el-table-column>
      </el-table>
    </el-card>

    <el-card
      v-if="
        detail &&
        detail.clearing_form_type === SETTLEMENT_OPTIONS.BILL_PAYMENT &&
        (detail.status === STATUS.BILLS_TO_BE_PAID ||
          detail.status === STATUS.DONE)
      "
      shadow="never"
      style="margin-bottom: 16px"
    >
      <!-- card body -->
      <div class="header-bar">
        <span>支付流水明细</span>
      </div>
      <el-table :data="tableWaterBills" border stripe>
        <template v-for="col in columnsWaterBills">
          <template v-if="col.prop === 'receipt'">
            <el-table-column
              :key="col.prop"
              :prop="col.prop"
              :label="col.label"
              :width="col.width"
            >
              <template slot-scope="{ row }">
                <img
                  :src="row.receipt[0]"
                  style="width: 60px; height: 60px"
                  @click="handleViewImages(row.receipt)"
                />
                <span v-if="row.receipt && row.receipt.length"
                  >共{{ row.receipt.length }}张</span
                >
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column
              :key="col.prop"
              :prop="col.prop"
              :label="col.label"
              :width="col.width"
            >
            </el-table-column>
          </template>
        </template>
      </el-table>
    </el-card>

    <el-card
      v-if="
        detail &&
        detail.clearing_form_type ===
          SETTLEMENT_OPTIONS.PURCHASE_ORDER_DEDUCTION &&
        (detail.status === STATUS.PENDING_PURCHASE_ORDER_DEDUCTION ||
          detail.status === STATUS.DONE)
      "
      shadow="never"
      style="margin-bottom: 16px"
    >
      <!-- card body -->
      <div class="header-bar">
        <span>代采单抵扣列表</span>
      </div>
      <el-table
        :data="tableDeductionForPurchasing"
        border
        stripe
        :max-height="850"
        show-summary
        :summary-method="getSummariesForDeductionForPurchasing"
      >
        <template v-for="(col, index) in columnsDeductionForPurchasing">
          <el-table-column
            v-if="col.prop === 'wcg_id'"
            :key="index"
            :prop="col.prop"
            :label="col.label"
            :width="col.width"
          >
            <template slot-scope="scope">
              <a
                :href="`${
                  isProduction
                    ? 'https://erpweb.yishouapp.com'
                    : 'http://erp26.yishou.com:8088'
                }/erp/#/home/purchaseorderdetail/${scope.row.wcg_id}`"
                target="_blank"
                style="text-decoration: none"
                >{{ scope.row.wcg_id }}</a
              >
            </template>
          </el-table-column>
          <el-table-column
            v-else
            :key="index"
            :prop="col.prop"
            :label="col.label"
            :width="col.width"
          >
          </el-table-column>
        </template>
      </el-table>
    </el-card>

    <el-card shadow="never" style="margin-bottom: 16px">
      <!-- card body -->
      <div class="header-bar">
        <span>操作日志</span>
      </div>

      <el-table :data="tableLogs" border stripe :max-height="850">
        <template v-for="(col, index) in columnsLogs">
          <el-table-column
            v-if="col.prop === 'remark'"
            :key="index"
            :prop="col.prop"
            :label="col.label"
            :width="col.width"
          >
            <template slot-scope="scope">
              <span style="margin-right: 8px">{{ scope.row.remark }}</span
              ><el-button
                v-if="scope.row.operate_type === '2' && scope.row.remark"
                type="text"
                @click="viewSnapshot(scope.row.log_id)"
              >
                查看快照</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            v-else
            :key="index"
            :prop="col.prop"
            :label="col.label"
            :width="col.width"
          >
          </el-table-column>
        </template>
      </el-table>
      <el-dialog
        title="让利计费规则"
        :visible.sync="dialogSnapshotVisible"
        width="30%"
        @close="handleConfirmSubmitClose"
      >
        <el-table :data="tableAccountingRulesSnapshot" border stripe>
          <el-table-column type="index" width="50" label="序号">
          </el-table-column>
          <el-table-column
            v-for="(col, index) in columnsAccountingRulesSnapshot"
            :key="index"
            :prop="col.prop"
            :label="col.label"
            :width="col.width"
          >
          </el-table-column>
        </el-table>
      </el-dialog>
    </el-card>
  </el-card>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

import * as vendorProfitConcessionApi from "@/controller/vendorProfitConcession3461.js";
import Global from "@/components/Global.vue";
import addZeroes from "@/utils/addZeroes.js";
import * as erpReturnProfitBillApi from "@/openapi/erp/ReturnProfitBill.js";

console.log("🚀 : addZeroes", addZeroes);

const isProduction = Global.environment === 1;

const STATUS = {
  PENDING_BUSINESS_REVIEW: 1, // 业务待审核
  PENDING_FINANCIAL_REVIEW: 2, // 财务待审核
  PENDING_VENDOR_CONFIRM: 3, // 商家待确认
  PENDING_PURCHASE_ORDER_DEDUCTION: 4, // 代采单待抵扣
  BILLS_TO_BE_PAID: 5, // 账单待支付
  DONE: 6, // 已完成
};

const SETTLEMENT_OPTIONS = {
  PURCHASE_ORDER_DEDUCTION: 1,
  BILL_PAYMENT: 2,
};

const constantMap = Object.freeze({
  maxImage: 3,
});
export default {
  name: "VendorProfitConcessionDetail",
  data() {
    return {
      constantMap,
      id: "",
      detail: null,
      tableLogs: [], // 操作日志
      tableWaterBills: [], // 流水
      tableSalesVolumeSummary: [], // 商品销量汇总表
      tableAmountDetails: [], // 金额明细
      tableDeductionForPurchasing: [], // 	代采单抵扣列表
      tableReachSalesTargetSummary: [], // 销售达标汇总表
      tableAccountingRules: [], // 让利计费规则
      tableAccountingRulesSnapshot: [], // 快照
      columnsLogs: [
        {
          label: "操作人",
          width: "",
          prop: "admin_name",
        },
        {
          label: "操作方式",
          width: "",
          prop: "operate_type_msg",
        },
        {
          label: "操作时间",
          width: "",
          prop: "created_at",
        },
        {
          label: "操作备注",
          width: "",
          prop: "remark",
        },
      ],
      columnsWaterBills: [
        {
          label: "支付方式",
          width: "",
          prop: "payment_type",
        },
        {
          label: "创建时间",
          width: "",
          prop: "pay_create_time",
        },
        {
          label: "支付金额",
          width: "",
          prop: "pay_price",
        },
        {
          label: "支付时间",
          width: "",
          prop: "pay_time",
        },
        {
          label: "支付状态",
          width: "",
          prop: "pay_status_msg",
        },
        {
          label: "交易流水号",
          width: "",
          prop: "brw_number",
        },
        {
          label: "线下支付回执",
          width: "",
          prop: "receipt",
        },
      ],
      columnsDeductionForPurchasing: [
        {
          label: "代采单编号",
          width: "",
          prop: "wcg_id",
        },
        {
          label: "代采来源",
          width: "",
          prop: "source",
        },
        {
          label: "代采单提交时间",
          width: "",
          prop: "create_time",
        },
        {
          label: "代采单状态",
          width: "",
          prop: "status",
        },
        {
          label: "已抵扣金额",
          width: "",
          prop: "deduction_price",
        },
      ],
      columnsAccountingRules: [
        {
          label: "月度销售件数达标门槛（按商品货号）",
          width: "",
          prop: "num",
        },
        {
          label: "让利单价（元/件）",
          width: "",
          prop: "price",
        },
      ],
      columnsAccountingRulesSnapshot: [
        {
          label: "月度销售件数达标门槛（按商品货号）",
          width: "",
          prop: "num",
        },
        {
          label: "让利单价（元/件）",
          width: "",
          prop: "price",
        },
      ],
      columnsAmountDetails: [
        {
          label: "结算方式",
          width: "",
          prop: "clearing_form",
        },
        {
          label: "总结算金额（元）",
          width: "",
          prop: "amount_price",
        },
        {
          label: "已抵扣/支付金额（元）",
          width: "",
          prop: "deduction_price",
        },
        {
          label: "待抵扣/支付金额（元）",
          width: "",
          prop: "stay_deduction_price",
        },
      ],
      columnsReachSalesTargetSummary: [
        {
          label: "月度销售件数达标门槛",
          width: "",
          prop: "section_number",
        },
        {
          label: "让利单价（元/件）",
          width: "",
          prop: "price",
        },
        {
          label: "达标商品款数",
          width: "",
          prop: "total_kh_num",
        },
        {
          label: "达标销售总件数",
          width: "",
          prop: "total_sale_num",
        },
        {
          label: "让利金额（元）",
          width: "",
          prop: "total_profit_price",
        },
      ],
      columnsSalesVolumeSummary: [
        {
          label: "商品名称",
          width: "",
          prop: "goods_name",
        },
        {
          label: "商品货号",
          width: "",
          prop: "goods_no",
        },
        {
          label: "商品款号",
          width: "",
          prop: "goods_kh",
        },
        {
          label: "符合让利的商品销售件数",
          width: "",
          prop: "stats_sale_num",
        },
        {
          label: "达标区间",
          width: "",
          prop: "section_number",
        },
        {
          label: "让利单价（元/件）",
          width: "",
          prop: "price",
        },
        {
          label: "让利金额（元）",
          width: "",
          prop: "return_profit_price",
        },
      ],
      dialogConfirmSubmitVisible: false,
      STATUS,
      dialogRefetchConfirmVisible: false,
      form: {
        reason: "",
      },
      rejectForm: {
        reason: "",
      },
      rules: {
        reason: [
          {
            required: true,
            message: "请输入原因",
            trigger: "blur",
          },
        ],
      },
      rejectRules: {
        reason: [
          {
            required: true,
            message: "请输入原因",
            trigger: "blur",
          },
        ],
      },
      formDone: {
        receipt: [],
      },
      doneRules: {
        receipt: [
          {
            required: true,
            message: "请上传图片",
            trigger: "change",
            type: "array",
          },
        ],
      },
      dialogConfirmReviewPassVisible: false,
      dialogRejectVisible: false,
      dialogDoneVisible: false,
      dialogSnapshotVisible: false,
      SETTLEMENT_OPTIONS,
      isProduction,
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.fetchData();
  },
  methods: {
    fetchData() {
      vendorProfitConcessionApi
        .getBillDetail({ bill_id: this.id })
        .then((res) => {
          this.tableLogs = res.log;
          this.tableWaterBills = res.flowing;
          this.tableSalesVolumeSummary = res.goods_summary;
          this.tableAmountDetails = res.amount_detail;
          this.tableDeductionForPurchasing = res.wcg_order;
          this.tableReachSalesTargetSummary = res.sales_summary;
          const { return_profit_rule: tableAccountingRules, ...rest } =
            res.info;

          this.tableAccountingRules = tableAccountingRules;
          this.detail = rest;
        });
    },
    getSummariesForSalesVolume(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === columns.length - 1) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => Number.isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!Number.isNaN(value)) {
                return parseFloat(this.$math.evaluate(`${prev} + ${curr}`));
              }
              return prev;
            }, 0);
            sums[index] = addZeroes(sums[index]);
          }
        }
      });

      return sums;
    },
    getSummariesForDeductionForPurchasing(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "汇总";
          return;
        }
        if (index === columns.length - 1) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => Number.isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!Number.isNaN(value)) {
                return parseFloat(this.$math.evaluate(`${prev} + ${curr}`));
              }
              return prev;
            }, 0);
            sums[index] = addZeroes(sums[index]);
          }
        }
      });

      return sums;
    },
    getSummariesForReachSalesTarget(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (
          column.property === "total_kh_num" ||
          column.property === "total_sale_num" ||
          column.property === "total_profit_price"
        ) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => Number.isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!Number.isNaN(value)) {
                return parseFloat(this.$math.evaluate(`${prev} + ${curr}`));
              }
              return prev;
            }, 0);
            if (column.property === "total_profit_price") {
              sums[index] = addZeroes(sums[index]);
            }
          }
        }
      });

      return sums;
    },
    showConfirmDialog() {
      this.dialogConfirmSubmitVisible = true;
    },
    handleBillCancel() {
      this.$confirm("作废后不可重新生成账单，确定作废吗？", "提示", {
        type: "warning",
      }).then(() => {
        erpReturnProfitBillApi
          .postCancelReturnBill({ bill_id: this.id })
          .then(() => {
            this.$message.success("操作成功");
            this.fetchData();
          })
          .catch(this.$noop);
      });
    },
    showConfirmReviewPassDialog() {
      this.dialogConfirmReviewPassVisible = true;
    },
    showRefetchConfirmDialog() {
      this.dialogRefetchConfirmVisible = true;
    },
    handleConfirmSubmitClose() {
      this.dialogConfirmSubmitVisible = false;
    },
    handleConfirmReviewPassClose() {
      this.dialogConfirmReviewPassVisible = false;
    },
    handleRefetchConfirmClose() {
      this.form = this.$options.data().form;
      this.$refs.form.resetFields();
      this.dialogRefetchConfirmVisible = false;
    },
    handleConfirmSubmit() {
      vendorProfitConcessionApi
        .submitBill({
          bill_id: this.id,
        })
        .then(() => {
          this.$message.success("提交成功");
          this.handleConfirmSubmitClose();
          this.fetchData();
        });
    },
    handleConfirmReviewPass() {
      vendorProfitConcessionApi
        .setExamineAdopt({
          bill_id: this.id,
        })
        .then(() => {
          this.$message.success("审核成功");
          this.handleConfirmReviewPassClose();
          this.fetchData();
        });
    },
    handleConfirmRefetch() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          vendorProfitConcessionApi
            .resetRuleConfig({
              bill_id: this.id,
              remark: this.form.reason,
            })
            .then(() => {
              this.$message.success("更新成功");
              this.handleRefetchConfirmClose();
              this.fetchData();
            });
        }
      });
    },
    exportList() {
      vendorProfitConcessionApi
        .importBillDetailList({ bill_id: this.id })
        .then((res) => {
          window.open(apiBaseURL + res.file);
        });
    },
    exportGoodsDetail() {
      vendorProfitConcessionApi
        .importBillGoodsDetailList({ bill_id: this.id })
        .then((res) => {
          window.open(apiBaseURL + res.file);
        });
    },
    showReviewRejectDialog() {
      this.dialogRejectVisible = true;
    },
    handleShowDoneDialog() {
      this.dialogDoneVisible = true;
    },
    handleRejectClose() {
      this.rejectForm = this.$options.data().rejectForm;
      this.$refs.rejectForm.resetFields();
      this.dialogRejectVisible = false;
    },
    handleDoneClose() {
      this.formDone = this.$options.data().formDone;
      this.$refs.formDone.resetFields();
      this.dialogDoneVisible = false;
    },
    handleConfirmReject() {
      this.$refs.rejectForm.validate((valid) => {
        if (valid) {
          vendorProfitConcessionApi
            .setExamineReject({
              bill_id: this.id,
              remark: this.rejectForm.reason,
            })
            .then(() => {
              this.$message.success("驳回成功");
              this.handleRejectClose();
              this.fetchData();
            });
        }
      });
    },
    handleConfirmDone() {
      this.$refs.formDone.validate((valid) => {
        if (valid) {
          const { receipt } = this.formDone;
          erpReturnProfitBillApi
            .postUploadReceipt({
              bill_id: this.id,
              receipt: receipt.map((item) =>
                typeof item === "string" ? item : item.name
              ),
            })
            .then(() => {
              this.$message.success("操作成功");
              this.handleDoneClose();
              this.fetchData();
            })
            .catch(this.$noop);
        }
      });
    },
    viewSnapshot(logId) {
      vendorProfitConcessionApi
        .getLogSnapshot({ log_id: logId })
        .then((res) => {
          this.tableAccountingRulesSnapshot = res.rule;
          this.dialogSnapshotVisible = true;
        });
    },
    handleViewImages(images) {
      this.$viewerApi({
        images,
      });
    },
  },
};
</script>
<style scoped>
.header-bar {
  background: #f3f3f3;
  height: 50px;
  line-height: 30px;
  padding: 0 25px;
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/VendorProfitConcessionDetail/VendorProfitConcessionDetail.vue